import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const EllipsisIcon = (props: IconProps) => (
  <Icon width="32px" height="32px" viewBox="0 0 32 32" {...props}>
    <path d="M8 13.333A2.674 2.674 0 0 0 5.333 16c0 1.467 1.2 2.667 2.667 2.667 1.467 0 2.667-1.2 2.667-2.667 0-1.467-1.2-2.667-2.667-2.667Zm16 0A2.674 2.674 0 0 0 21.333 16c0 1.467 1.2 2.667 2.667 2.667 1.467 0 2.667-1.2 2.667-2.667 0-1.467-1.2-2.667-2.667-2.667Zm-8 0A2.674 2.674 0 0 0 13.333 16c0 1.467 1.2 2.667 2.667 2.667 1.467 0 2.667-1.2 2.667-2.667 0-1.467-1.2-2.667-2.667-2.667Z" />
  </Icon>
);

export default memo(EllipsisIcon);
